<template>
  <el-pagination
    :page-size="props.data.showCount"
    :current-page="props.data.currentPage"
    style="margin-top: 20px"
    background
    layout="total, sizes, prev, pager, next, jumper"
    :page-sizes="[5, 10, 50, 100]"
    :total="props.data.totalCount"
    @current-change="handleCurrentChange"
    @size-change="handleSizeChange"
  ></el-pagination>
</template>

<script setup>
  import { defineProps, defineEmits } from "vue";
  const props = defineProps(["data"]);
  const emit = defineEmits(["updatePage", "updateSize"]);

  const handleCurrentChange = (val) => {
    emit("updatePage", val);
  };
  const handleSizeChange = (val) => {
    emit("updateSize", val);
  };
</script>

<style lang="scss" scoped>
  .el-pagination {
    margin: 10px 0;
  }
</style>
